import { render, staticRenderFns } from "./MainCreationManage.vue?vue&type=template&id=22a359c2&"
import script from "./MainCreationManage.vue?vue&type=script&lang=js&"
export * from "./MainCreationManage.vue?vue&type=script&lang=js&"
import style0 from "./MainCreationManage.vue?vue&type=style&index=0&id=22a359c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports